document.addEventListener("turbo:load", function() {
  // disable create button on load if there is no default value in select tag
  const checkout = document.getElementById("create-account");
  const select = document.querySelector("select");

  // if default value is empty
  if (select.selectedIndex == -1) {
    checkout.disabled = true;
  }
})